export default from './image-loader';



// WEBPACK FOOTER //
// ./app/components/image-loader/index.js